import React from 'react'
import ArticleInPromotionComponent from '../components/articlePromotion/ArticleInPromotion.Component';

const ArticleInPromotionPageComponent = () => {
  return <ArticleInPromotionComponent />
}

export default ArticleInPromotionPageComponent;